import {getUser} from '@/store/userStore'
import menu from '@/router/menu'
import menuForShop from '@/router/menuForShop'
import menuCw1 from '@/router/menuCw1'
import menuKf1 from '@/router/menuKf1'
import menuKf2 from '@/router/menuKf2'
import menuKf3 from '@/router/menuKf3'
import menuKf4 from '@/router/menuKf4'
import menuKf5 from '@/router/menuKf5'
import menuJs1 from '@/router/menuJs1'
import menuSy from '@/router/menuSy'

const userMenus = ()=>{
  const user = getUser()
  if(user.user.role == 1){
    return menu
  } else if(user.user.role == 2){
    return menuForShop
  }else if(user.user.role == 101){
    return menuKf1
  } else if(user.user.role == 102){
    return menuKf2
  } else if(user.user.role == 103){
    return menuKf3
  } else if(user.user.role == 104){
    return menuKf4
  } else if(user.user.role == 105){
    return menuKf5
  } else if(user.user.role == 201){
    return menuCw1
  } else if(user.user.role == 301){
    return menuJs1
  } else if(user.user.role == 401){
    return menuSy
  }
  return []
}

export default userMenus